import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Remove injected "Made with Emergent" badge (uses inline !important, so JS removal is required)
const killBadge = () => {
  document
    .querySelectorAll('#emergent-badge, a[href*="emergent.sh"], a[href*="emergent-badge"]')
    .forEach((el) => el.remove());
};
killBadge();
new MutationObserver(killBadge).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
setInterval(killBadge, 1000);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
